import { IMAGE_ROOT } from "../../config/env-vars";

export function removeCSSClass(ele, cls) {
  const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
  ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname) => pathname;

export const toAbsoluteImageURL = (pathname) => IMAGE_ROOT + pathname;
